export default "__VITE_ASSET__BLtG_c2q__"